import { Controller } from '@hotwired/stimulus';
import Collapse from 'bootstrap/js/dist/collapse';
import BootstrapSelect from '../select/bootstrap-select'

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [ 'mobile', 'desktop', 'inside', 'outside', 'balcony', 'suite', 'promo', 'special', 'price', 'date', 'link', 'details' ]
    static values = {
        dates: Object,
        detailsurl: String,
        cols: Number,
        dateindex: Number
    }

    connect() {
        window.addEventListener('resize', event => {
            this.setColumns()
        })

        this.locale = document.documentElement.lang.replace('_', '-')

        this.offerUrl = this.linkTarget.href
        this.detailsLoaded = false
        this.detailsCollapse = new Collapse(this.detailsTarget, { toggle: false });
        this.detailsTarget.addEventListener('shown.bs.collapse', event => IBE.scrollToElement(event.target))
        
        this.setColumns()
    }

    setColumns() {
        if (!IBE.isMobile) {
            this.colsValue = Math.floor((this.desktopTarget.parentElement.offsetWidth - 48) / 57)
        } else {
            this.colsValue = -1
        }
    }

    colsValueChanged() {
        const $inner     = this.desktopTarget.querySelector('.carousel-inner')
        $inner.innerHTML = ''

        if (this.colsValue > -1) {
            this.mobileTarget.innerHTML = ''

            let pageCount  = 0
            let activePage = 0
            let html       = ''
            const target   = this.desktopTarget.id
            const prevNext = `<button class="carousel-control-next h1" type="button" data-bs-target="#${target}" data-bs-slide="next"><span class="carousel-control-next-icon" aria-hidden="true"></span></button>`

            this.mobileTarget.classList.add('d-none')
            this.desktopTarget.classList.remove('d-none')
            // render
            this.datesValue.d.forEach((date, index) => {
				if (index % this.colsValue == 0) {
					pageCount++;
					html += '<div class="carousel-item">';
				}

                const dt = new Date(date.r)

				html += '<span class="xt-date' + (index === this.dateindexValue ? ' active' : '') + '" data-index="' + index + '" data-action="click->offer#select">'
                        + '<span class="xt-month">' + dt.toLocaleDateString(this.locale, { month: 'short', timeZone: 'UTC' }) + '</span>'
                        + '<span class="xt-day">' + dt.toLocaleDateString(this.locale, { day: '2-digit', timeZone: 'UTC' }) + '</span>'
                        + '<span class="xt-year">' + dt.toLocaleDateString(this.locale, { year: 'numeric', timeZone: 'UTC' }) + '</span>'
                    + '</span>';

                if (index === this.dateindexValue) {
                    activePage = pageCount - 1;
                }

				var k = index + 1;
				
				if (k % this.colsValue == 0 || k == this.datesValue.d.length) {
					html += '</div>';
				}

				if (k == this.datesValue.d.length) {
					$inner.innerHTML = html
					$inner.querySelector('.xt-date.active').parentElement.classList.add('active')

                    const next = $inner.parentElement.querySelector('.carousel-control-next')

					if (pageCount > 1 && !next) {
						$inner.parentElement.insertAdjacentHTML('beforeend', prevNext)
					}
                    if (pageCount == 1 && next) {
                        next.remove()
                    }
				}
            })
        } else {
            this.mobileTarget.classList.remove('d-none')
            this.desktopTarget.classList.add('d-none')
            var options = this.datesValue.d.map((date, index) => '<option value="' + index + '"' + (index === this.dateindexValue ? ' selected="selected"' : '') + '>' + this.formatDateShort(date.r) + ' (' + date.m + ')' + '</option>').join('')

            this.mobileTarget.innerHTML = '<select data-action="offer#choice" class="form-select">' + options + '</option>'
        }
    }

    dateindexValueChanged() {
        if (this.colsValue > -1) {
            this.desktopTarget.querySelector('.xt-date.active')?.classList.remove('active')
            const activeXtDate = Array.from(this.desktopTarget.querySelectorAll('.xt-date')).find(item => Number(item.dataset.index) === this.dateindexValue)

            if (activeXtDate) {
                activeXtDate.classList.add('active')
                if (activeXtDate.parentElement.parentElement.querySelector('.carousel-item.active') !== activeXtDate.parentElement) {
                    activeXtDate.parentElement.parentElement.querySelector('.carousel-item.active')?.classList.remove('active')
                    activeXtDate.parentElement.classList.add('active')
                }
            }
        }

        const activeDate = this.datesValue.d[this.dateindexValue]

        this.promoTargets.forEach(promo => {
            if (Number(promo.dataset.index) === activeDate.pi) {
                promo.classList.remove('d-none')
            } else {
                promo.classList.add('d-none')
            }
        })

        this.specialTargets.forEach(special => {
            if (Number(special.dataset.index) === activeDate.si) {
                special.classList.remove('d-none')
            } else {
                special.classList.add('d-none')
            }
        })

        this.offerUrl = this.datesValue.u.replace('__CID__', activeDate.c)

        this.linkTargets.forEach(link => {
            link.href = this.offerUrl
        })

        this.insideTargets.forEach((item, index) => {
            if (this.dateindexValue === index) {
                item.classList.remove('d-none')
                this.outsideTargets[index].classList.remove('d-none')
                this.balconyTargets[index].classList.remove('d-none')
                this.suiteTargets[index].classList.remove('d-none')
                this.priceTargets[index].classList.remove('d-none')
            } else if (!item.classList.contains('d-none')) {
                item.classList.add('d-none')
                this.outsideTargets[index].classList.add('d-none')
                this.balconyTargets[index].classList.add('d-none')
                this.suiteTargets[index].classList.add('d-none')
                this.priceTargets[index].classList.add('d-none')
            }
        })

        if (this.detailsLoaded) {
            this.detailsTarget.querySelector('select').value = this.dateindexValue
            if (this.bss) {
                this.bss.refresh()
            }
            this.setItineraryDates()
        }
    }

    setItineraryDates() {
        Array.from(this.detailsTarget.querySelectorAll('table.xt-itinerary tbody td[data-day]')).forEach(td => {
            const start = new Date(this.datesValue.d[this.dateindexValue].rc); // rc = raw cruise date
			start.setHours(12)
            const d = start.getDate();
            start.setFullYear(start.getFullYear(), start.getMonth(), d + parseInt(td.dataset.day) - 1);
            td.innerHTML = start.toLocaleDateString(this.locale, {
                year: 'numeric',
                month: '2-digit', 
                day: '2-digit', 
				timeZone: 'UTC'
            })
        })
    }

    choice() {
        this.dateindexValue = Number(this.mobileTarget.querySelector('select').value)
    }

    choiceItinerary(event) {
        this.dateindexValue = Number(event.currentTarget.value)
    }

    select(event) {
        this.dateindexValue = Number(event.currentTarget.dataset.index)
    }

    details() {
        if (false === this.detailsLoaded) {
            this.detailsTarget.innerHTML = '<p class="placeholder-glow"><span class="placeholder col-12"></span></p>'
            this.detailsCollapse.show()

            fetch(this.detailsurlValue)
                .then(data => data.text())
                .then(html => {
                    this.detailsLoaded = true
                    this.detailsTarget.innerHTML = html

                    const groupDate = Array.from(this.datesValue.d).map(r => r.rc).reduce((r, a, index) => {
                        const key = this.formatDateGroup(a)
                        r[key] = r[key] || []
                        r[key].push({
                            date: a,
                            index: index
                        })
                        return r
                    }, Object.create(null))
                    
                    const select = this.detailsTarget.querySelector('select')

                    if (select) {
                        select.innerHTML = Object.keys(groupDate).map(group => {
                            return '<optgroup label="' + group + '">' +
                                groupDate[group].map(date => '<option value="' + date.index + '"' + (date.index === this.dateindexValue ? ' selected="selected"' : '') + '>' + this.formatDateShort(date.date) + '</option>').join('') +
                            '</optgroup>'
                        }).join('')

                        this.bss = new BootstrapSelect(select, { mobile: IBE.isMobile })
                        
                        this.setItineraryDates()
                    }

                    this.linkTargets.forEach(link => {
                        link.href = this.offerUrl
                    })
                })
        } else {
            this.detailsCollapse.toggle()
        }
    }

    formatDateShort (strDate) {
        const dt = new Date(strDate)

        return dt.toLocaleDateString(this.locale, {
            year: 'numeric',
            month: '2-digit', 
            day: '2-digit', 
			timeZone: 'UTC'
        })
    }

    formatDateGroup (strDate) {
        const dt = new Date(strDate)

        return dt.toLocaleDateString(this.locale, {
            year: 'numeric',
            month: 'long', 
			timeZone: 'UTC'
        })
    }
}